import removeDiacritics from '../remove-diacritics'

export function convertToSlug(str?: string) {
  return str
    ? removeDiacritics(str)
        .toLowerCase()
        .replace(/\//gi, '')
        .replace(/\./gi, '')
        .replace(/ {1,}/gi, '-')
    : ''
}

export default convertToSlug
